var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"loading-text",class:{ shining: _vm.isShining }},[_vm._v(" 唱片正在加载中 ... ")]),_c('PosterGenerator',{ref:"posterGenerator"}),_c('Loading',{ref:"loading"}),_c('Share',{ref:"shareBar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }